import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Logger} from "dce-logger";
import {I18n} from "../../../../dce-i18n/lib";
import {InternalDropzoneOptions} from "./internal/InternalDropzoneOptions";
import DropzoneLoader from "./internal/DropzoneLoader";

interface DropzoneFileProps {
    label: string;
    fieldId: string;
    uploadUrl: string;
    accept?: string;
    maxFileSize?: number;
    triggerChange?: boolean
}
//
// async function importDropzone() {
//
//     //import * as Dropzone from "dropzone";
//     let Dropzone = ;
//
//     //Dropzone.autoDiscover = false;
//
//     console.log(Dropzone);
//
//     return Dropzone;
// }



@Dce("DropzoneFile")
export default class DropzoneFile extends DceComponent<DropzoneFileProps> {

    private logger = Logger.of("DropzoneFile");

    private block: JQuery<HTMLElement>;
    private field: JQuery<HTMLElement>;
    private dropzone: Dropzone;

    constructor(elem: DceHTMLElement, props: DropzoneFileProps) {
        super(elem, props);
        this.logger.debug("Init S");

        this.block = $(this.elem);

        this.field = this.block.find('#' + this.props.fieldId);

        let previewTpl = this.block.find('.upload-item').html()
        let previewCont = this.block.find('.upload-list')[0];

        //import(/* webpackChunkName: "dropzone" */ 'dropzone').then(DropzoneModule => {

        DropzoneLoader.load().then(Dropzone_ => {

            //console.log("Dropzone in then", DropzoneModule);

            //let Dropzone_ = (DropzoneModule as any).default as Dropzone;

            let options:InternalDropzoneOptions = {
                url: this.props.uploadUrl,
                createImageThumbnails: false,
                previewTemplate: previewTpl,
                previewsContainer: previewCont,
                hiddenInputContainer: this.elem,
                uploadMultiple: false,
                withCredentials: true,

                //dzielenie na kawałki po 2MB
                chunking: true
            };

            if (I18n.has('dropzoneI18N')) {
                options = {
                    ...options,
                    ...I18n.get('dropzoneI18N')
                }
            }

            if (this.props.accept) {
                options.acceptedFiles = this.props.accept;
            }

            if (this.props.maxFileSize) {
                options.maxFilesize = this.props.maxFileSize;
            }

            // @ts-ignore
            this.dropzone = new Dropzone_(this.block.find('.dropzone')[0], options);

            this.dropzone.on('complete', file => {
                this.uploadComplete(file);
            });

        })

        this.block.on('click', '[data-remove=1]', e => {
            $(e.target).closest('.file-item').remove();
            this.toggleZone();

            this.field.val("");

            if(this.props.triggerChange){
                this.field.trigger('change');
            }

            var emptyclone = this.block.find('.empty-file-item').clone();
            emptyclone.css('display', 'block');

            this.block.find('.file-row').append(emptyclone);

        });

        this.toggleZone();

    }

    private uploadComplete(file:Dropzone.DropzoneFile){

        if(file.status == 'success'){

            var jsonResp = JSON.parse(file.xhr.response);

            if(jsonResp.hasOwnProperty('response')){

                $(file.previewElement).slideUp(200);

                if(this.props.triggerChange){
                    this.field.trigger('change');
                }


                this.field.val(jsonResp['data']['id']);

                var html = jsonResp['response'].replace('{{form}}', "");
                this.block.find('.file-row').html(html);

                this.toggleZone();

                //if(self.uploadCallback){
                    //self.uploadCallback(jsonResp);
                //}

            }else{

                setTimeout(function () {
                    $(file.previewElement).slideUp(200);
                }, 800);

            }

        }
    }

    private toggleZone(){
        if(this.block.find('.file-row .file-item').length > 0){
            this.block.find('.dropzone').hide();
            this.block.find('.upload-file-progress.dz-error').remove();
        }else{
            this.block.find('.dropzone').show();
        }
    };

}
